export default __webpack_public_path__ + "static/media/Shower_Icon.99e0033a.svg";